import React from "react";
import { HexGridOverlay } from "./components/GridGenerator";
import "./App.css";

function App() {
  return (
    <div className="App">
      <HexGridOverlay />
    </div>
  );
}

export default App;
